import React from 'react';

import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section about">
            <h3>About Us</h3>
            <p style={{textAlign:'justify'}}>
              At AROGYAKUNJ HOMOEOPATHIC CLINIC, we follow a holistic and classical homeopathic approach to restore health naturally. Homeopathy works by stimulating the body’s innate healing power, addressing the root cause rather than just symptoms.
            </p>
          </div>

          <div className="footer-section links">
            <h3>Quick Links</h3>
            <ul style={{marginLeft:'50px'}}>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/About">About</Link></li>
              <li><Link to="/Service">Services</Link></li>
              <li><Link to="/Gallery">Gallery</Link></li>
              <li><Link to="/Contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section services">
            <h3>Open Clinic </h3>
            <ul>
              <p className="mb-0 text-white small">
                <strong>Monday to Saturday:</strong><br/> Morning: 9:30 AM – 1:00 PM <br/> Evening: 6:00 PM – 8:00 PM<br />
                <strong>Sunday:</strong> 10:00 AM – 12:30 PM
              </p>

            </ul>
          </div>

          <div className="footer-section contact">
            <h3>Contact</h3>
            <p>✉️:   arogyakunjhomeoclinic@gmail.com</p>
            <p> 📞 :  +91 8100154008</p>
            <p>📍 : Ground Floor Shanti Tara Plaza  Sultanpur Rd, Arjunganj, Marhar Mau Kala, Lucknow, Uttar Pradesh 226002
            </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} AROGYAKUNJ HOMOEOPATHIC. All Rights Reserved. Powered By Creative Digital World</p>
        </div>
      </footer>

      {/* Sticky WhatsApp Button */}
      <a
        href="https://wa.me/918100154008"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="https://img.icons8.com/color/48/000000/whatsapp--v1.png" alt="WhatsApp" />
      </a>





      <div className="icon-bar">
        <a href="#" class="facebook"><i class="fa fa-facebook"></i></a>
        <a href="#" class="twitter"><i class="fa fa-twitter"></i></a>
        <a href="https://www.google.com" class="google"><i class="fa fa-instagram"></i></a>
        <a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a>
        <a href="#" class="youtube"><i class="fa fa-youtube-play"></i></a>
      </div>







    </>
  );
};

export default Footer;
